module.exports = __webpack_public_path__ + "static/Alberta-bc9e7000de0f5766471dd489780561be.png";